// Mock data for VVA Chapter 240 website

export const chapterInfo = {
  name: "Vietnam Veterans of America",
  chapter: "Chapter 240",
  location: "Sumner County, Tennessee",
  chartered: "November 24, 1986",
  motto: "Never again will one generation of veterans abandon another.",
  phone: "888-548-0085",
  meetingLocation: "VFW Post #9851, 73 New Shackle Island Road, Hendersonville, TN",
  meetingSchedule: "1st Monday of each month. Dinner at 6PM, Meeting at 7PM",
};

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1626836014893-37663794dca7",
    title: "Honoring Those Who Served",
    subtitle: "Vietnam Veterans of America, Chapter 240",
    tag: "Sumner County, Tennessee",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1685389213849-088712cbd3fe",
    title: "Never Again Will One Generation",
    subtitle: "Abandon Another.",
    tag: "Our Sacred Promise Since 1986",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1773434032753-4ab4b4f1f1d3",
    title: "Service, Sacrifice, Brotherhood",
    subtitle: "Standing With Every Veteran Who Answered The Call",
    tag: "501(c)19 Service Organization",
  },
];

export const stats = [
  { number: "38+", label: "Years of Service", detail: "Since 1986" },
  { number: "501(c)19", label: "Service Organization", detail: "Federally Recognized" },
  { number: "12", label: "Monthly Meetings", detail: "Every First Monday" },
  { number: "1000s", label: "Veterans Supported", detail: "And Still Counting" },
];

export const activities = [
  {
    id: "golf",
    title: "Bobby Rager Memorial Golf Tournament",
    subtitle: "Freedom Ain't Free",
    tagline: "Annual Fundraiser",
    image: "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1200&auto=format&fit=crop",
    icon: "Flag",
    date: "To Be Announced",
    location: "Country Hills Golf Course, Hendersonville, TN",
    description:
      "Sponsored by Family Legacy, our annual 4-person scramble raises vital funds for Sumner County veterans. Includes a shotgun start, closest-to-the-pin contest, target drive challenge, and lunch.",
    details: [
      "Registration starts 6:45 AM",
      "Shotgun start at 8:00 AM",
      "Entry $75 includes green fees, cart, range balls, gift bag, and lunch",
      "All proceeds benefit Sumner County veterans",
    ],
    contact: "Byron Personett  |  615-594-1153",
    link: "/golf-tournament",
  },
  {
    id: "fishing",
    title: "Annual Bass Fishing Tournament",
    subtitle: "Freedom Ain't Free",
    tagline: "$2,000 Guaranteed First Place Prize",
    image: "https://images.unsplash.com/photo-1551942296-97384c850440?w=1200&auto=format&fit=crop",
    icon: "Fish",
    date: "To Be Announced",
    location: "Flipper's Bait & Tackle, 200 Odoms Bend Rd., Gallatin",
    description:
      "Anglers of all skill levels are welcome to compete on beautiful Old Hickory Lake for cash prizes and camaraderie. Every dollar raised supports Sumner County veterans and their families.",
    details: [
      "Registration begins 4:15 AM",
      "Entry fee $100 per boat / $110 day of tournament",
      "$2,000 guaranteed first place prize",
      "Proceeds support veteran families",
    ],
    contact: "Chapter Office  |  888-548-0085",
    link: "/fishing-tournament",
  },
  {
    id: "santa",
    title: "Operation Santa Claus",
    subtitle: "Christmas Gift Program",
    tagline: "A Little Magic For Every Child",
    image: "https://images.unsplash.com/photo-1571915096107-c6606c216058?w=1200&auto=format&fit=crop",
    icon: "Gift",
    date: "December, Annually",
    location: "Sumner County",
    description:
      "Every December, Chapter 240 members and volunteers bring smiles to children throughout Sumner County by providing Christmas gifts to families who need a helping hand.",
    details: [
      "Serving Sumner County children",
      "Volunteers welcome year-round",
      "Sponsorships and donations accepted",
      "Spreading joy since inception",
    ],
    contact: "Chapter Office  |  888-548-0085",
    link: "#",
  },
  {
    id: "foodbank",
    title: "Chapter 240 Food Bank",
    subtitle: "Sumner County Weekly Support",
    tagline: "Nourishing Families In Need",
    image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1200&auto=format&fit=crop",
    icon: "HandHeart",
    date: "Every Saturday",
    location: "Chapter 240 Facility",
    description:
      "Our doors open every Saturday morning to serve neighbors facing food insecurity. No questions asked. Just dignified support for the families who call Sumner County home.",
    details: [
      "Saturdays, 9:00 AM to 11:00 AM",
      "Open to all Sumner County residents",
      "Volunteer opportunities available",
      "Non-perishable donations welcome",
    ],
    contact: "Chapter Office  |  888-548-0085",
    link: "#",
  },
];

export const timeline = [
  {
    year: "1986",
    title: "Chartered",
    description: "Chapter 240 was officially chartered on November 24, 1986 as a 501(c)19 service organization.",
  },
  {
    year: "1990s",
    title: "Community Roots",
    description: "Established annual fishing and golf tournaments, launching decades of veteran-focused fundraising.",
  },
  {
    year: "2000s",
    title: "Sumner County Veterans Park",
    description: "Chapter 240 designed and dedicated a lasting memorial for local men and women who served, from WWI through Iraq.",
  },
  {
    year: "Today",
    title: "Still Standing",
    description: "Meeting monthly, feeding families, honoring the fallen, and lifting up the next generation of veterans.",
  },
];

export const testimonials = [
  {
    quote:
      "Chapter 240 stood by my family when we needed it most. These men and women live the promise every single day.",
    author: "Retired Sergeant, U.S. Army",
    role: "Sumner County Resident",
  },
  {
    quote:
      "The Veterans Park is a sacred place. Seeing my father's name engraved is something our family will treasure forever.",
    author: "Family Member",
    role: "Wall of Honor Contributor",
  },
  {
    quote:
      "Every Saturday at the food bank reminds me that service doesn't end when the uniform comes off.",
    author: "Chapter Volunteer",
    role: "Weekly Contributor",
  },
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1621534864185-19a06671ed23",
  "https://images.unsplash.com/photo-1585502094744-8943e25971fa",
  "https://images.unsplash.com/photo-1658845543013-c1d3d03d37af",
  "https://images.unsplash.com/photo-1780668117245-af606acd76d9",
  "https://images.unsplash.com/photo-1773434035272-11ba3043c2e2",
  "https://images.unsplash.com/photo-1685389213849-088712cbd3fe",
];

export const contacts = {
  flagCeremony: {
    name: "Jerry Carmack",
    email: "jerryd.carmack@gmail.com",
    phone: "(615) 633-2489",
    role: "Flag Ceremony, Color Guard & Honor Guard",
  },
  golf: {
    name: "Byron Personett",
    email: "personet@aol.com",
    phone: "615-594-1153",
    role: "Golf Tournament Coordinator",
  },
  chapter: {
    name: "Chapter 240 Office",
    email: "info@vva240.org",
    phone: "888-548-0085",
    role: "General Inquiries",
  },
};
